import React, { useState, useEffect } from "react"
import classNames from "classnames"

import styles from "./styles.module.scss"

interface Props {
	className?: string

	hideVideo?: boolean
	data: {
		banner: {
			mediaContent: JSX.Element // Главная картинка
			desktopBanner: JSX.Element // Десткоп баннер
			logo: JSX.Element // Логотип
			quote: string | JSX.Element // Цитата
		}
		heading: string | JSX.Element // Заголовок h1
		textarea: string | JSX.Element // Описание
		video: {
			src: string // ссылка
			textarea: string | JSX.Element // Описание
		}
	}
	bannerClassName?: string
	titleClassName?: string
}

// Компонент заголовок, описание и подсказка слева
// Пример: /secret/ohmybowl
export default function MainBanner(props: Props) {
	const data = props.data || []
	const hideVideo = props.hideVideo || false

	const [isGrayScale, setIsGrayScale] = useState(true)

	// При клике убирать grayscale
	function handleBlur() {
		if (typeof document === undefined) return

		if (document.activeElement === document.querySelector("iframe")) {
			setIsGrayScale(false)
		}
	}

	useEffect(() => {
		if (typeof window === undefined) return

		window.addEventListener("blur", handleBlur)
		return () => {
			window.removeEventListener("blur", handleBlur)
		}
	})
	// При клике убирать grayscale //

	return (
		<section className={classNames(styles.container, props.className)}>
			<div className={styles.content__column}>
				<div className={styles.mediaContent}>
					{data.banner.mediaContent}
					<div className={classNames(styles.banner, props.bannerClassName)}>
						{data.banner.desktopBanner}
					</div>
					<div className={styles.logo}>{data.banner.logo}</div>
				</div>

				<p className={styles.quote}>{data.banner.quote}</p>

				<h1 className={classNames(styles.heading, props.titleClassName)}>
					{data.heading}
				</h1>
				<div className={styles.textarea}>{data.textarea}</div>

				{!hideVideo && (
					<div className={styles.videoContent}>
						<div
							className={classNames(styles.media, {
								[styles.media__grayscale]: isGrayScale,
							})}
						>
							<iframe
								src={data.video.src}
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							></iframe>
						</div>
						{data.video.textarea}
					</div>
				)}
			</div>
		</section>
	)
}
